import type { AllISO2Codes, AllISO3Codes, ISO2Code, ISO3Code } from "./iso-map"
import { env } from "@/lib/env"
import { iso2ToIso3Map, iso3ToIso2Map } from "./iso-map"

export function getCountryISO3(countryCode: AllISO2Codes): ISO3Code {
  if (!countryCode) {
    throw new Error("Country code is required")
  }
  const parsedCountry = countryCode.toUpperCase() as ISO2Code

  if (typeof parsedCountry !== "string") {
    throw new TypeError("Country code should be a string")
  }

  if (parsedCountry.length !== 2) {
    throw new Error("Country code should be 2 characters long")
  }

  const iso3Code = iso2ToIso3Map[parsedCountry]
  if (iso3Code === undefined) {
    if (parsedCountry === "VN") {
      return "VIE"
    }
    throw new Error(`No ISO3 reference was found for ISO2 "${parsedCountry}"`)
  }

  return iso3Code
}

export function getCountryISO2(countryCode: AllISO3Codes): ISO2Code {
  if (!countryCode) {
    throw new Error("Country code is required")
  }
  const parsedCountry = countryCode.toUpperCase() as ISO3Code
  if (typeof parsedCountry !== "string") {
    throw new TypeError("Country code should be a string")
  }

  if (parsedCountry.length !== 3) {
    throw new Error("Country code should be 3 characters long")
  }
  const iso2Code = iso3ToIso2Map[parsedCountry]
  if (iso2Code === undefined) {
    if (parsedCountry === "VIE") {
      return "VN"
    }
    throw new Error(`No ISO2 reference was found for ISO3 "${parsedCountry}"`)
  }

  return iso2Code
}

export function getCountryFlagIcon(countryCode: AllISO3Codes | AllISO2Codes): string {
  try {
    let iso2Code: string

    // Si el código tiene 2 caracteres, asumimos que es ISO2
    if (countryCode.length === 2) {
      iso2Code = countryCode.toUpperCase()
    }
    // Si el código tiene 3 caracteres, convertimos de ISO3 a ISO2
    else if (countryCode.length === 3) {
      iso2Code = getCountryISO2(countryCode as AllISO3Codes)
    }
    else {
      throw new Error(`Invalid country code length: ${countryCode}`)
    }

    const championship = env.NEXT_PUBLIC_CHAMPIONSHIP || "CIS"

    if (championship === "JJB") {
      return `/assets/brasil_flags/${iso2Code}.png`
    }
    else {
      // Por defecto usa la ruta CIS
      return `/flags/small/${iso2Code.toLowerCase()}.webp`
    }
  }
  catch (error) {
    console.log(error)
    // Fallback según el campeonato
    const championship = env.NEXT_PUBLIC_CHAMPIONSHIP
    if (championship === "JJB") {
      return "/assets/brasil_flags/BR.png"
    }
    else if (championship === "CIS") {
      return "/flags/small/es.png"
    }
    else {
      return "/flags/small/es.webp"
    }
  }
}
